import { createFileRoute } from '@tanstack/react-router';

import { ProductionPlannerGridView } from '../../features/production-planner/production-planner-grid-view';

export const Route = createFileRoute('/production-planner/')({
  staticData: { section: 'Planner', breadcrumb: 'Production Planner' },
  component: ProductionPlannerGridView,
});
